export default {
    methods: {
        fillSnack(
            typeMessage,
            titleMsg,
            bodyMsg,
            showProgress = false,
            timeout = 0,
            showCloseBtn = true,
            closeBtnMessage = 'cerrar'
        ) {
            let payloadSnack = {
                typeMessage: typeMessage,
                message: {
                    title: titleMsg,
                    body: bodyMsg,
                },
                timeout: timeout,
                showProgress: showProgress,
                showCloseBtn: showCloseBtn,
                closeBtnMessage: closeBtnMessage,
            }
            return payloadSnack
        },
    },
}
